<template>
  <BaseDialog
    title="會員資料同步確認"
    btn1="確認同步"
    btn2="取消"
    :btn1Loading="loading"
    append-to-body
    @close="handleClose"
    @confirm="handleConfirm"
  >
    <span>系統將同步提供資料至{{ shopName }}</span>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref } from 'vue'
import BaseDialog from './BaseDialog.vue'
import { RegisterShopMemberByUser } from '@/api/member'
import { useShop } from '@/use/shop'
import { useRouter } from 'vue-router/composables'
import { get } from 'lodash'

export default defineComponent({
  name: 'SyncMemberDialog',
  components: {
    BaseDialog,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    shopName: {
      type: String,
      required: true,
    },
    navigateOnSuccess: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close', 'success'],
  setup (props, { emit }) {
    const loading = ref(false)
    const { shopId } = useShop()
    const router = useRouter()

    const handleClose = () => {
      window.$message.warning('會員同步失敗')
      emit('close')
    }

    const handleConfirm = async () => {
      loading.value = true
      const [res, err] = await RegisterShopMemberByUser({
        shopId: shopId.value,
        userId: props.userData.user.id,
      })
      loading.value = false

      if (err) {
        window.$message.error(err)
        return
      }

      window.$message.success('會員同步成功')
      emit('success', res)
      emit('close')

      if (props.navigateOnSuccess) {
        // 導航至會員資料頁面
        router.push({
          name: 'MemberProfile',
          params: { id: get(res, 'member.id') },
        })
      }
    }

    return {
      loading,
      handleClose,
      handleConfirm,
    }
  },
})
</script>

<style lang="postcss" scoped>
</style>
